import { Component, ElementRef, EventEmitter, HostListener, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { BehaviorSubject, Observable, Subject, debounceTime, distinctUntilChanged, exhaustMap, filter, first, last, map, merge, mergeMap, of, share, skip, switchMap, take, tap } from 'rxjs';
import { SearchSelectService } from './search-select.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MobileSelectionComponent } from './mobile-selection/mobile-selection.component';
import { Language } from '../modals/edit-about/language/language.component';

const widthAnimation = trigger('widthAnimation', [
  state('*', style({
    width: '*',
    overflow: 'hidden'
  })),
  transition(':leave', [
    style({ width: '*', overflow: 'hidden' }),
    animate('200ms ease-in-out', style({ width: '0px', overflow: 'hidden' }))
  ])
]);

export type ItemType = {
  id: number;
  name: string;
  province?: string;
  country?: string;
  username?: string;
  logo: string;
  native_name?: string;
}

@Component({
  selector: 'app-search-select',
  templateUrl: './search-select.component.html',
  styleUrls: ['./search-select.component.scss'],
  animations: [widthAnimation]
})
export class SearchSelectComponent {
  @Input() config: { rounded: boolean, roundedFull?: boolean } = { rounded: false, roundedFull: false }
  @Input() layer: number = 0;
  @Input() initSelectItem: { id: number, name: string } | ItemType | Language | null | undefined;
  @Input() type: 'school' | 'city' | 'language' | 'field' | 'organ' | 'work_field' = 'city';
  @Input() isCheck: boolean = false;
  @Input() invalidClass: any
  @Input() specificHeight: any
  @Output() emitId: EventEmitter<ItemType | null> = new EventEmitter();
  @Output() emitCustom: EventEmitter<string> = new EventEmitter();
  @Output() emitCreateObs: EventEmitter<Observable<any> | null> = new EventEmitter();
  nextPageUrl: string | null = null;
  items: Subject<ItemType[] | null> = new Subject();
  itemsObs: Observable<ItemType[] | null> = this.items.asObservable().pipe(
    share(),
  )
  focusSubject: Subject<null | string> = new Subject()
  focusObs: Observable<null | string> = this.focusSubject.asObservable()
  inputName: string | null = null;
  selectedItem: any | ItemType | null = null;
  dontCheckInput: string | null = null;
  cloneItem: any
  canCreate: boolean = false
  focusInput = false
  @ViewChild('searchSelectInput') input: ElementRef | undefined
  constructor(
    private formBuilder: UntypedFormBuilder,
    private searchSelect: SearchSelectService,
    private dialog: MatDialog,
    private device: DeviceDetectorService,
    private elRef: ElementRef,
  ) { }
  formGroup = this.formBuilder.group({
    control: new UntypedFormControl(),
  })
  ngOnChanges(changes: SimpleChanges) {
    // console.log(this.invalidClass);
  }
  ngOnInit(): void {
    this.cloneItem = Object.assign({}, this.initSelectItem)
    this.getItemsObs().subscribe()
    setTimeout(() => {
      this.initialSelectedItem()
    });
  }
  initialSelectedItem(): void {
    // console.log(this.initSelectItem)
    if (this.initSelectItem && this.initSelectItem.name) {
      this.selectedItem = this.initSelectItem
      this.emitId.emit(this.selectedItem)
      this.formGroup.controls['control'].setValue(
        this.type == 'language' ? `${this.selectedItem?.name} (${this.selectedItem?.native_name})` : this.selectedItem?.name
      )
    }
  }
  showError(): boolean {
    let val: any = this.formGroup.controls['control'].value
    // console.log(!this.selectedItem , !this.canCreate)
    return this.isCheck && (val == '' || val == null || val == undefined) || (val != this.initSelectItem?.name && (!this.canCreateString() && !this.selectedItem))
  }
  isOk(): boolean {
    let val: any = this.formGroup.controls['control'].value
    // console.log(this.type, this.canCreateString())
    return !this.isCheck || this.selectedItem != null || this.canCreateString() && (val && val != '' && val != null)
  }
  getIsShowOnBottom(): boolean {
    let child = this.input?.nativeElement!.getBoundingClientRect()
    let parent = document.getElementById('search-select-parent')!.getBoundingClientRect()
    // console.log('parent', parent ,'child', child)
    return parent.bottom > child.bottom + 150
  }
  isMobile(): boolean { return this.device.isMobile() }
  getInputValue(): Observable<string> {
    return this.formGroup.controls['control'].valueChanges.pipe(
      skip(!this.initSelectItem ? 1 : 2),
      tap(i => {
        this.selectedItem = null;
        this.emitId.emit(null)
        this.inputName = i;
      }),
      filter((s: string) => {
        if (!this.dontCheckInput || this.dontCheckInput != s)
          return true
        else
          this.dontCheckInput = null
        return false
      }),
      distinctUntilChanged(),
      debounceTime(300),
    )
  }
  getItemsObs(): Observable<any> {
    return this.getInputValue().pipe(
      switchMap((text) => this.searchSelect.getItems(this.type, text).pipe(
        map((result: any) => {
          // if(result.results.length>0)
          //   this.items.next(result.results)
          this.items.next(result.results)
          this.nextPageUrl = result.next
          let index: number = result.results.findIndex((r: any) => r.name == text)
          this.canCreate = this.canCreateString() && index <= -1
          if (index <= -1)
            if (this.canCreateString())
              this.createString()
            else
              this.selectedItem = null
          else
            this.selectItem(result.results[index], false)
        })
      )),
    )
  }
  setValue(item: any) {
    return item.name
  }

  selectItem(item: ItemType, close: boolean = true) {
    this.formGroup.controls['control'].setValue(item.name, { emitEvent: false })
    this.selectedItem = item;
    this.emitId.emit(item)
    // this.dontCheckInput = item.name
    if (close)
      this.items.next(null)
  }
  isNotExist(itemList: ItemType[] | null): boolean {
    if (this.inputName == null || itemList == null)
      return false
    return itemList.findIndex(element => element.name == this.inputName) <= -1
  }
  reset(): void {
    // console.log('reset')
    this.items.next(null)
  }
  openMobileSelection(): void {
    this.dialog.open(MobileSelectionComponent, {
      disableClose: true,
      id: `mobile-selection-${this.layer}`,
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: this.isMobile() ? '100vh' : 'auto',
      data: {
        isMobile: this.isMobile(),
        type: this.type,
        selectedItem: this.selectedItem,
        layer: this.layer,
      }
    }).afterClosed().subscribe(
      item => {
        this.selectedItem = item;
        this.emitId.emit(item)
      }
    )
  }
  resetSelectedItem(): void {
    this.selectedItem = null;
  }
  focus(e: any) {
    this.focusSubject.next(e.target.value)
  }
  changeFocus(focusInput: any) {
    this.focusInput = focusInput
    // console.log(focusInput);
  }
  canCreateString(): boolean {
    // return merge(
    //   this.itemsObs.pipe(
    //     map((results:any)=>{
    //       let value = this.formGroup.controls['control'].value
    //       console.log('dar meni', this.type=='organ' && value!='' && value!=undefined && results.findIndex((r:any)=>r==value)<=-1)
    //       console.log(this.type=='organ')
    //       console.log(value!='')
    //       console.log( value!=undefined )
    //       console.log(results.findIndex((r:any)=>r==value)<=-1)
    //       return this.type=='organ' && value!='' && value!=undefined && results.findIndex((r:any)=>r==value)<=-1
    //     })
    //   )
    // )
    return (this.type == 'school' || this.type == 'field' || this.type == 'organ' || this.type == 'work_field')
  }
  createString() {
    // console.log('create string')
    let form: FormData = new FormData()
    switch (this.type) {
      case ('work_field'): {
        form.append('name', this.formGroup.controls['control'].value)
        if (this.formGroup.controls['control'].value && this.formGroup.controls['control'].value != '')
          this.emitCreateObs.emit(this.formGroup.controls['control'].value)
        else
          this.emitCreateObs.emit(null)
        break
      }
      case ('organ'): {
        form.append('name', this.formGroup.controls['control'].value)
        if (this.formGroup.controls['control'].value && this.formGroup.controls['control'].value != ''){
          this.emitCreateObs.emit(this.formGroup.controls['control'].value)
          this.emitCustom.emit(this.formGroup.controls['control'].value)
        }
        else
          this.emitCreateObs.emit(null)
        break
      }
      case ('school'): {
        this.emitCustom.emit(this.formGroup.controls['control'].value)
        // this.items.next(null)
        this.canCreate = false
        // form.append('additional_data', JSON.stringify({company_name: this.formGroup.controls['control'].value}))
        break
      }
      case ('field'): {
        this.emitCustom.emit(this.formGroup.controls['control'].value)
        // this.items.next(null)
        this.canCreate = false
        // form.append('additional_data', JSON.stringify({company_name: this.formGroup.controls['control'].value}))
        break
      }
      default: {
        break;
      }
    }
  }
  manageStyleClass() {
    if (this.focusInput) {
      return 'focusInput'
    }
    else if (!this.focusInput && (this.invalidClass || !this.isOk())) {
      return 'invalidError'
    }
    else {
      return 'notFocusInput'
    }
  }
}
